import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { CourseList } from "@/features/training/components/course-list"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"
import { ensureArray } from "@/features/training/utils/ensure-array"

export function AIAgentsWhatIsPage() {
  const { t } = useTranslation("", { keyPrefix: "training.ai-agents.what-is" })
  const list = <T = string,>(key: string) => ensureArray<T>(t(key, { returnObjects: true }))

  return (
    <CourseLayout>
      <CourseSection>
        <h1>{t("title")}</h1>
        <h2>{t("purpose.title")}</h2>
        <p>{parse(t("purpose.description"))}</p>
        <p>
          <strong>{t("purpose.what_you_gain")}</strong>
        </p>
        <CourseList data={list("purpose.benefits")} />
        <p>
          <em>{t("purpose.level")}</em>
        </p>
      </CourseSection>

      <CourseSection>
        <h2>{t("learning_objectives.title")}</h2>
        <p>{parse(t("learning_objectives.description"))}</p>
        <CourseList data={list("learning_objectives.objectives")} />
      </CourseSection>

      <CourseSection>
        <h2>{t("what_are_agents.title")}</h2>
        <p>{parse(t("what_are_agents.description"))}</p>
        <blockquote className="border-warning bg-warning/15 border-l-4 p-4">
          <p>{parse(t("what_are_agents.warning"))}</p>
        </blockquote>
      </CourseSection>

      <CourseSection>
        <h2>{t("three_levels.title")}</h2>
        <p>{parse(t("three_levels.description"))}</p>
        <img
          alt="Three levels of AI complexity"
          className="border-border my-4 h-auto w-full rounded-lg border shadow-sm"
          src="/assets/training_images/ai-agents/01.jpeg"
        />

        <h3>{t("three_levels.level1.title")}</h3>
        <CourseList data={list("three_levels.level1.features")} />

        <h3>{t("three_levels.level2.title")}</h3>
        <p>{parse(t("three_levels.level2.description"))}</p>
        <CourseList data={list("three_levels.level2.features")} />
        <p className="mt-2">
          <strong>{parse(t("three_levels.level2.example"))}</strong>
        </p>

        <h3>{t("three_levels.level3.title")}</h3>
        <p>{parse(t("three_levels.level3.description"))}</p>
        <CourseList data={list("three_levels.level3.features")} />
        <p className="mt-2">
          <strong>{parse(t("three_levels.level3.example"))}</strong>
        </p>
      </CourseSection>

      <CourseSection>
        <h2>{t("summary.title")}</h2>
        <CourseList data={list("summary.points")} />
        <p>{parse(t("summary.next_module"))}</p>
      </CourseSection>
    </CourseLayout>
  )
}
